"use strict";
/*
 * Permissions management system, define access level for each of
 * your server apis, and restrict users by giving them access levels
 *
 * Copyright (C) 2020 Adam van der Kruk aka TacB0sS
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DBDef_PermissionAccessLevel = void 0;
const ts_common_1 = require("@nu-art/ts-common");
const Validator_PermissionAccessLevel = {
    domainId: ts_common_1.tsValidateUniqueId,
    name: ts_common_1.tsValidateStringWithDashes,
    value: (0, ts_common_1.tsValidateIsInRange)([[0, 1000]]),
    _auditorId: (0, ts_common_1.tsValidateString)()
};
exports.DBDef_PermissionAccessLevel = {
    validator: Validator_PermissionAccessLevel,
    dbName: 'permissions--level',
    entityName: 'permissions--level',
    lockKeys: ['domainId']
};
